import React from "react"
import { Link } from "react-router-dom"

const PageNotFound = () => {
  document.getElementsByTagName("title")[0].innerHTML = `Page not found`
  return (
    <div className="uk-margin-auto uk-margin-large-top">
      <h1 className="app-text">Ooops, Page not found</h1>
      <Link to="/" className="">
        Go Home
      </Link>
    </div>
  )
}

export default PageNotFound
